// NowVsFutureSection.jsx
import React, { useState, useEffect } from "react";
import NowVsFutureComparison from "./NowVsFutureComparison";
import Phone from "./Phone";

export default function NowVsFutureSection() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      // adjust 640 to whatever breakpoint you actually want
      setIsMobile(window.innerWidth <= 640);
    };

    checkWidth(); // run once on mount
    window.addEventListener("resize", checkWidth);

    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  return (
    <div className="nowvsfut-wrapper">
      {isMobile ? (
        // MOBILE ONLY
        <div className="nowvsfut" style={{marginTop: "1rem"}}>
          <NowVsFutureComparison />
        </div>
      ) : (
        // DESKTOP/TABLET ONLY
        <div className="nowvsfutphone">
          <Phone position="center" size="small">
            <NowVsFutureComparison />
          </Phone>
        </div>
      )}
    </div>
  );
}
